<div class="contract" fxLayout="row" fxLayoutAlign="start">

    <div (click)="toggleContractExpanded()">
        <i class='glyphicon glyphicon-chevron-right pointer' *ngIf="!isExpanded"></i>
        <i class='glyphicon glyphicon-chevron-down pointer' *ngIf="isExpanded"></i>
    </div>
    <div fxFlex="auto">
        <div *ngIf="!isExpanded">
            <a (click)='openContract(contract)'>
                <b><span [innerHTML]="contract.contractType | highlight: searchTerm"></span></b>:
                <span [innerHTML]="contract.description | highlight: searchTerm"></span>
            </a>
        </div>

        <mat-expansion-panel>
            <table class="contractTable" style="page-break-inside: avoid;">
                <tr>
                    <td colspan="2">
                        <a (click)='openContract(contract)'>
                            <b><span [innerHTML]="contract.contractType | highlight: searchTerm"></span></b>:
                            <span [innerHTML]="contract.description | highlight: searchTerm"></span>
                        </a>
                    </td>
                </tr>

                <tr>
                    <td style="width: 15%;">Value:</td>
                    <td><span [hidden]="contract.value == null || contract.value < 0.01">$
                            {{contract.value | number:'1.2-2'}} Million</span></td>
                </tr>

                <tr>
                    <td>Award Date:</td>
                    <td>{{contract.awardDate | date:'d MMMM yyyy'}}</td>
                </tr>


                <tr style="vertical-align: top;">
                    <td>
                        <span [hidden]="stage!='Awarded'">Contractor:</span>
                        <span [hidden]="stage=='Awarded'">Companies:</span>
                    </td>
                    <td>

                        <!--
                                Table of Company Details
                                Contains repeating lists of involved and uninvolved companies
                                Uninvolved companies are hidden in the 'Awarded' block
                                -->
                        <table class="contractCompaniesTable" style="width: 100%;">
                            <tr style="vertical-align: top;">
                                <td style="padding: 0">
                                    <div [hidden]="contract.involvedCompanies.length<=0 || stage=='Awarded'">
                                        <u>{{contract.involvedCompaniesHeading}}</u>
                                    </div>

                                    <table>
                                        <tr *ngFor="let company of contract.involvedCompanies">
                                            <td style="padding: 0;">
                                                <div *ngIf="company.isUnnamedConsortium">
                                                    Consortium Consisting of:
                                                </div>
                                                <!-- if the company is not an unnamed consortium, just show the copany name -->
                                                <div *ngIf="!company.isUnnamedConsortium">
                                                    <span
                                                        [innerHTML]="company.companyName | highlight: searchTerm"></span>
                                                    <a href="{{company.companyURL}}" *ngIf="company.companyURL"
                                                        target="_blank">
                                                        <i class="glyphicon glyphicon-globe"></i>
                                                    </a><br>
                                                </div>
                                                
                                                <!-- if the company is an unamed consortium, list the participants -->
                                                <table style="margin-left: 20px">
                                                    <tr *ngFor="let participant of company.participants">
                                                        partici[ant: {{participant.companyURL}}
                                                        <td style="padding: 0;">
                                                            <div>
                                                                <span
                                                                    [innerHTML]="participant.companyName | highlight: searchTerm"></span>
                                                                <a href="{{participant.companyURL}}"
                                                                    *ngIf="participant.companyURL" target="_blank">
                                                                    <i class="glyphicon glyphicon-globe"></i>
                                                                </a>
                                                            </div>

                                                            <eic-company-offices-and-contacts [company]="participant"></eic-company-offices-and-contacts>

                                                        </td>
                                                    </tr>
                                                </table>
                                                <eic-company-offices-and-contacts [company]="company"></eic-company-offices-and-contacts>

                                            </td>
                                        </tr>
                                    </table>

                                </td>

                                <td *ngIf="stage!='Awarded'" rowspan="3">

                                    <div [hidden]="contract.uninvolvedCompanies.length==0">
                                        <u>{{contract.uninvolvedCompaniesHeading}}</u>
                                    </div>
                                    <ul *ngFor="let company of contract.uninvolvedCompanies">
                                        <li>
                                            <span>
                                                {{company.companyName}}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>

                        </table>

                    </td>
                </tr>
                <tr *ngIf="(contract?.projects?.length??0)>1">
                    <td colspan="2">
                        This contract is also associated with:
                        <ul *ngFor="let p of contract.projects">
                            <!-- This component needs to know the id of the project that  is currently being diplayed-->
                            <li *ngIf="currentProject.id != p.projectID">
                                <a (click)="openProject(p)">
                                    <span [innerHTML]="p.name | highlight: searchTerm">{{p.name}}</span>
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>
            </table>

        </mat-expansion-panel>
    </div>

</div>
